import { motion } from 'framer-motion';
import hello from '@/assets/mascot/dofi-hello.webp';
import joy from '@/assets/mascot/dofi-joy.webp';
import proud from '@/assets/mascot/dofi-proud.webp';
import think from '@/assets/mascot/dofi-think.webp';
import calm from '@/assets/mascot/dofi-calm.webp';
import support from '@/assets/mascot/dofi-support.webp';
import welcome from '@/assets/mascot/dofi-welcome.webp';
import calmIcon from '@/assets/mascot/dofi-calm-icon.webp';
import thinkIcon from '@/assets/mascot/dofi-think-icon.webp';
import joyIcon from '@/assets/mascot/dofi-joy-icon.webp';

/**
 * Маскот Дофи (полное имя Дофаминчик) — с 22.09.2026 вместо прежнего
 * персонажа «Слава». Образ 08A: шар с лицом в стеклянном пузыре, три сферы
 * на орбитах. Старые позы (wave / celebrate / thumb / think) сохранены
 * как имена, чтобы экраны, где маскот уже стоял, переключились без правок.
 *
 * compact — версия БЕЗ пузыря для мелких мест (аватар ~36–64 px): стекло
 * с бликами на таком размере превращается в мутное пятно, проверено на
 * реальных картинках. Иконок нарисовано три (спокойный, думает, радость),
 * остальные позы в компактном виде берут ближайшую по настроению.
 *
 * Грусти и укора в наборе нет намеренно: человек после срыва или паузы
 * должен встретить тепло, а не расстроенное лицо (анти-стыд).
 */
export type MascotPose =
  | 'wave' | 'celebrate' | 'thumb' | 'think'
  | 'calm' | 'support' | 'welcome';

const FULL: Record<MascotPose, string> = {
  wave: hello,
  celebrate: joy,
  thumb: proud,
  think,
  calm,
  support,
  welcome,
};

const COMPACT: Record<MascotPose, string> = {
  wave: calmIcon,
  celebrate: joyIcon,
  thumb: joyIcon,
  think: thinkIcon,
  calm: calmIcon,
  support: calmIcon,
  welcome: joyIcon,
};

// Лёгкое «дыхание»-покачивание — живой, без видео.
export function Mascot({
  pose = 'calm',
  className,
  float = true,
  compact = false,
}: {
  pose?: MascotPose;
  className?: string;
  float?: boolean;
  compact?: boolean;
}) {
  return (
    <motion.img
      src={(compact ? COMPACT : FULL)[pose]}
      alt="Дофи"
      draggable={false}
      className={className}
      style={{ objectFit: 'contain' }}
      animate={float ? { y: [0, -5, 0], rotate: [-2, 2, -2], scale: [1, 1.03, 1] } : undefined}
      transition={float ? { duration: 4, repeat: Infinity, ease: 'easeInOut' } : undefined}
    />
  );
}
